/* eslint-disable @typescript-eslint/no-explicit-any */

import axios from 'axios';
import * as setting from './webSetting';
import _ from 'lodash';

interface ServerRes{
    isError:boolean,
    msg : string,
    [key : string] : any;
}

type TypeServerJSON = Promise<object|null>;
type TypeServerString = Promise<string|null>;

export class _ServerApi {
    private static instance: _ServerApi;
    private static API_URL = setting.API_URL;
    //"corss 없애는 조건"
    private static config = {
        headers: {
            'Content-Length': 0,
            'Content-Type': 'text/plain',
        },
        
    };

    
    


    private constructor() {
        return;
    }
    public static getInstance(): _ServerApi {
        if (!_ServerApi.instance) {
            _ServerApi.instance = new _ServerApi();
        }
        return _ServerApi.instance;
    }
    public async postJson(url: string, param: object): Promise<ServerRes> {
        try {
            
            const fullurl = _ServerApi.API_URL + url;
            const result = await axios.post(fullurl, param,{
                withCredentials: true,
            });
            if(result == null){
                console.log("getJson : 서버통신 오류--------------->");
                console.log(result);
                throw new Error();
            }
            const rv = result.data as ServerRes;
            return rv;
        }
        catch (e : any) {
            console.trace("error : postJson");
            if(!_.isUndefined(e.stack)){
                console.error(e.stack);
            }
            const rv:ServerRes = {
                isError: true,
                msg : "network error"
            }
            return rv;
        }
    }

    public async postJsonSendFile(url: string, file: Blob): Promise<ServerRes> {
        try {
            const fullurl = _ServerApi.API_URL + url;
            const frm = new FormData();
            frm.append("uploadImg",file);
            
            const result = await axios.post(fullurl, frm,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true,

            });
            if(result == null){
                console.log("getJson : 서버통신 오류--------------->");
                console.log(result);
                throw new Error();
            }
            const rv = result.data as ServerRes;
            return rv;
        }
        catch (e : any) {
            console.trace("error : postJson");
            if(!_.isUndefined(e.stack)){
                console.error(e.stack);
            }
            const rv:ServerRes = {
                isError: true,
                msg : "network error"
            }
            return rv;
        }
    }

}
